import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { PaymentInfoModel } from 'src/app/core/models/payment-info.model';
import { PaymentModel } from 'src/app/core/models/payment.model';
import { RefundPaymentModel } from 'src/app/core/models/refund-payment.model';
import { IdentityService } from 'src/app/core/services/identity.service';
import { RefundPaymentService } from 'src/app/core/services/refund-payment.service';
import { ConfirmarDialogComponent } from 'src/app/shared/components/confirmar-dialog/confirmar-dialog.component';
import { DialogCommerceComponent } from 'src/app/shared/components/dialog-commerce/dialog-commerce.component';
import { currencyToNumber, getCleanStringNumber, getCurrencyValue } from 'src/app/shared/functions/currency.functions';
import { environment as cenv } from 'src/environments/environment';
import { environment as denv } from 'src/environments/environment.demo';
import { DetailPaymentService } from '../../../detail-pay/services/detail.payment.service';
import { PaymentsService } from '../../../../core/services/payments.service';
import { billeteras, pspDemo, pspProd } from '../../../../shared/functions/wallets-names';
import { AppIcon } from 'src/app/shared/interfaces/app-icon';
import { PaymentIconsService } from 'src/app/core/services/payment-icons.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { ReturnDetailModel } from '../../../../core/models/returnDetail.model';
import { StorageService } from 'src/app/core/services/storage.service';
import { PrintCloverTicketService } from 'src/app/core/services/print-clover-ticket.service';
import { CloverService } from 'src/app/core/services/clover.service';
import { deviceMessageId } from '../../../../core/enums/device-message-id.enum';
import { NativeBridgeService } from '../../../../core/services/native-bridge.service';
import { deviceEnvironmentId } from 'src/app/core/enums/device-environment-id';

@Component({
  selector: 'app-operation-detail',
  templateUrl: './operation-detail.component.html',
  styleUrls: ['./operation-detail.component.scss']
})
export class OperationDetailComponent implements OnInit {
  @ViewChild('inputCash') inputCash: ElementRef;

  private readonly ONLY_NUMBERS: RegExp = new RegExp(/^[$\d]*$/g);
  private readonly MINIMIZED: string = 'minimized';
  private readonly MAXIMIZED: string = 'maximized';
  private readonly CURRENT_ENV = cenv.apiURL;
  private readonly DEMO_ENV = denv.apiURL;
  private get value(): string {
    return this.inputCash.nativeElement.value;
  }
  public deviceEnvironmentId = deviceEnvironmentId;

  downloadLoading: boolean;
  form: UntypedFormGroup;
  data: PaymentModel;
  isRefund: boolean = false;
  cashOutInputCurrency: string = '$0,00';
  isChecked: boolean = true;
  montoValid: boolean = false;
  habilitarForm: boolean = true;
  montoDown: boolean = true;
  errorIndex: number = 0;
  isErrorMax: boolean = false;
  isErrorMin: boolean = false;
  isErrorZero: boolean = false;
  isInvalid: boolean = false;
  matDialog: MatDialogRef<DialogCommerceComponent>;
  valueClean: number = 0;
  refundLoading: boolean = false;
  isCommerce: boolean = false;
  infoPayment: PaymentInfoModel;
  saldo: number = 0;
  presentRefunds: boolean = false;
  dataPaymentDetail: any[] = [];
  dataReturnsDetail: ReturnDetailModel[] = [];
  recibeTransferencia: boolean = false;
  textButton: string = 'Imprimir';
  tipoTransaccion: string = 'Transacción';
  tituloMovimiento: string = 'Comisiones e Impuestos';
  totalDescuentos: number = 0;
  totalDevoluciones: number = 0;
  loading: boolean = false;
  operationId: string;
  environment: string;
  dataMovementDetail: IMovementDetail;

  get monto() {
    return this.form.get('monto').value;
  }

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private detailStorage: DetailPaymentService,
    private formBuilder: UntypedFormBuilder,
    private refundPaymentService: RefundPaymentService,
    private dialog: MatDialog,
    private identityService: IdentityService,
    private paymentService: PaymentsService,
    private paymentIconsService: PaymentIconsService,
    private notificationService: NotificationService,
    private storage: StorageService,
    private printCloverTtkService: PrintCloverTicketService,
    private cloverService: CloverService,
    private nativeBridgeService: NativeBridgeService
  ) {
    this.environment = this.storage.get('appEnvironment');
    this.environment !== this.deviceEnvironmentId.CLOVER ? (this.textButton = 'Descargar') : null;
  }

  async ngOnInit() {
    this.route.queryParams.subscribe((queryParams) => {
      this.operationId = queryParams['operationId'];
      this.getMovementById();
    });

    this.isCommerce = this.identityService.isCommerce();

    this.form = this.formBuilder.group({
      monto: new UntypedFormControl('', { updateOn: 'blur', validators: [Validators.required] })
    });

    setTimeout((x) => {
      this.form.controls['monto'].setValue(this.cashOutInputCurrency);
    }, 300);

    this.form.controls['monto'].valueChanges.subscribe((value) => {
      this.valueClean = currencyToNumber(value);
      this.isErrorMax = this.valueClean > this.saldo ? true : false;
      this.isInvalid = this.valueClean == 0 ? true : false;
    });

    this.recibeTransferencia = this.isPCTType();
  }

  async getMovementById() {
    this.loading = true;

    const [paymentDetail, movementDetail] = await Promise.all([
      this.paymentService.getPaymentDetail(+this.operationId),
      this.paymentService.getMovementDetail(+this.operationId)
    ]);

    this.dataPaymentDetail = paymentDetail;
    this.dataMovementDetail = movementDetail;

    if (this.dataReturnsDetail && this.dataPaymentDetail) {
      this.data = new PaymentModel();
      this.data.fechaAcreditacion = this.dataMovementDetail.fechaAcreditacion;
      this.data.estado = this.dataMovementDetail.estado;
      this.data.fecha = new Date(this.dataMovementDetail.fecha);
      this.data.id = this.dataMovementDetail.id;
      this.data.monto = this.dataMovementDetail.monto;
      this.data.observaciones = this.dataMovementDetail.observaciones;
      this.data.titulo = this.dataMovementDetail.titulo;
      this.data.transform();
      this.data.cuilCuitContraparte = this.dataMovementDetail.cuilCuitContraparte;
      this.data.importe = this.dataMovementDetail.monto;

      this.data.descripcion = this.dataMovementDetail.descripcion;
      this.data.tipoMovimiento = this.dataMovementDetail.tipoTransaccion;
      this.data.conceptoTipo = this.dataMovementDetail.conceptoTipo;
      this.data.cvuContraparte = this.dataMovementDetail.cvuContraparte;
      this.data.debinId = this.dataMovementDetail.debinId;
      this.data.mpTipo.descripcion = this.dataMovementDetail.mpTipo.descripcion;
      this.data.caja = this.dataMovementDetail.caja;
      this.data.sucursal = this.dataMovementDetail.sucursal;
      this.data.conceptoTipo = this.dataMovementDetail.conceptoTipo;
      this.data.mpTipo.descripcion = this.dataMovementDetail.mpTipo.descripcion;
      this.data.mpTipo.id = this.dataMovementDetail.mpTipo.id;
      this.data.mpTipo.nombre = this.dataMovementDetail.mpTipo.nombre;

      this.tipoTransaccion = this.getTipoTransaccion();
      this.dataPaymentDetail = await this.paymentService.getPaymentDetail(+this.operationId);
      this.getNetoAcreditado();
      this.totalDescuentos = this.dataPaymentDetail ? this.getTotalDescuentos(this.dataPaymentDetail) : null;
      this.loading = false;
    }
  }

  getTipoTransaccion() {
    return this.isRefundType() ? 'Devolución' : this.data?.mpTipo?.descripcion;
  }

  isRefundType(): boolean {
    return this.data?.conceptoTipo == conceptoTipoEnum.DEVOLUCION;
  }

  isPCTType(): boolean {
    return this.data?.mpTipo?.id == 32;
  }

  isPixType(): boolean {
    return this.data?.mpTipo?.id == 42;
  }

  isTransferenciaBancariaType(): boolean {
    return this.data?.mpTipo?.id == 30;
  }

  isPagoConQRType(): boolean {
    return this.data?.mpTipo?.id == 33;
  }

  buttonStatus(): boolean {
    return this.isErrorMax || this.isInvalid;
  }

  imprimir(): void {
    window.print();
  }

  getIcon(): AppIcon {
    return this.data?.medioPagoView == 'Transferencia 3.0'
      ? this.getWallet(this.data)
      : this.paymentIconsService.getIcon(this.data?.medioPagoView, this.data?.billetera, this.data?.conceptoTipo);
  }

  getWalletDom(wallet): string {
    let name = this.isDemo() ? pspDemo[wallet] : pspProd[wallet];
    return !name ? 'Desconocido' : name;
  }

  getWallet(mov): AppIcon {
    let psp = mov.cvuContraparte ? mov.cvuContraparte.slice(3, 7) : '';
    return mov.billetera == null
      ? this.paymentIconsService.getIcon(mov.medioPagoView, this.getWalletDom(psp))
      : mov.billetera !== null && this.isPSP(mov.billetera)
      ? this.paymentIconsService.getIcon(mov.medioPagoView, this.getWalletDom(mov.billetera))
      : mov.billetera !== null && !this.isPSP(mov.billetera)
      ? this.paymentIconsService.getIcon(mov.medioPagoView, mov.billetera)
      : null;
  }

  maskPrice(price: string): string {
    if (price?.startsWith('-')) {
      let importe = price.slice(1);
      return `-$${importe}`;
    } else {
      return `$${price}`;
    }
  }

  onKeyup(event: KeyboardEvent): void {
    let slicedValue = getCleanStringNumber(this.value);
    if (event.key != 'Backspace' && !slicedValue.match(this.ONLY_NUMBERS)) {
      slicedValue = slicedValue.slice(0, -1);
    }

    this.cashOutInputCurrency = this.inputCash.nativeElement.value = getCurrencyValue(slicedValue);
  }

  validarForm(monto): void {
    monto = monto <= 0 || isNaN(monto) ? (this.montoValid = false) : (this.montoValid = true);
  }

  async refundPaymentSubmit(data: RefundPaymentModel): Promise<void> {
    this.refundLoading = true;
    await this.refundPaymentService.refusePayment(data);
    this.refundLoading = false;
  }

  refund(dialogConfig: MatDialogConfig, payment: RefundPaymentModel): void {
    const dialogRef = this.dialog.open(ConfirmarDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(async (response) => {
      if (response) {
        sessionStorage.removeItem(this.MINIMIZED);
        sessionStorage.removeItem(this.MAXIMIZED);
        await this.refundPaymentSubmit(payment);
      }
    });
  }

  submitRefund(partial: boolean): void {
    const dialogConfig = new MatDialogConfig();
    let refundMsg = partial
      ? `Estás a punto de devoler ${this.cashOutInputCurrency} del pago total, ¿Queres continuar?`
      : 'Estas a punto de devolver la totalidad del pago, ¿Queres continuar?';
    let payment = partial
      ? new RefundPaymentModel(this.data.id, 'partial refund', this.valueClean)
      : new RefundPaymentModel(this.data.id, 'refund all', null);
    dialogConfig.data = {
      id: 1,
      title: refundMsg,
      info: 'Atención!'
    };
    this.refund(dialogConfig, payment);
  }

  printTkt() {
    if (this.environment === this.deviceEnvironmentId.CLOVER) {
      this.printCloverTtkService.openPrintTicketConfirmationPopup(this.data?.id);
    } else {
      this.downloadLoading = true;
      const dialogConfig = new MatDialogConfig();
      dialogConfig.data = {
        id: 1,
        info: 'Descargar comprobante',
        title: '¿Está seguro que desea descargar el comprobante?'
      };

      const dialogRef = this.dialog.open(ConfirmarDialogComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(async (response) => {
        if (response) {
          this.paymentService
            .downloadTicket(this.data?.id)
            .then(() => {
              this.downloadLoading = false;
            })
            .catch(() => {
              this.downloadLoading = false;
            });
        } else {
          this.downloadLoading = false;
        }
      });
    }
  }

  checkEvent(completed: boolean): void {
    this.habilitarForm = completed;
  }

  setClassEstado(estado): string {
    if (estado == 'Confirmado') return 'confirmado';
    else if (estado == 'Acreditado') return 'acreditado';
    else if (estado == 'Aprobado') return 'confirmado';
    else if (estado == 'Pendiente') return 'pendiente';
    else if (estado == 'Anulado') return 'anulado';
    else return 'error';
  }

  setClassEstadoMovDetalleMovimiento(estado): string {
    if (estado == 'C') return 'confirmadoRenglon';
    else if (estado == 'D') return 'confirmadoRenglon';
    else if (estado == 'A') return 'confirmadoRenglon';
    else if (estado == 'P') return 'pendienteRenglon';
    else if (estado == 'U') return 'anuladoRenglon';
    else if (estado == 'N') return 'anuladoRenglon';
    else return 'error';
  }

  setEstadoMovDetalleMovimiento(estado): string {
    if (estado == 'C') return 'Confirmado';
    else if (estado == 'D') return 'Acreditado';
    else if (estado == 'A') return 'Aprobado';
    else if (estado == 'P') return 'Pendiente';
    else if (estado == 'U') return 'Anulado';
    else if (estado == 'N') return 'Cancelado';
    else return 'Error';
  }

  goBack(): void {
    this.isRefund = false;
    this.habilitarForm = true;
    this.cashOutInputCurrency = '$0,00';
    this.form.get('monto').setValue(this.cashOutInputCurrency);
  }

  async showRefund(data: PaymentModel): Promise<void> {
    this.infoPayment = await this.refundPaymentService.getPaymentInfo(data.id);
    this.saldo = currencyToNumber(this.infoPayment.saldo);
    this.isChecked = this.infoPayment.devoluciones.length > 0 ? false : true;
    this.presentRefunds = this.infoPayment.devoluciones.length > 0 ? true : false;
    this.habilitarForm = this.infoPayment.sumDevoluciones > 0 && this.saldo !== 0 ? false : true;
    this.isRefund = !this.isRefund;
  }

  tipoMov(data: PaymentModel): boolean {
    switch (data.mpTipo.id) {
      case 30:
        return false;
      case 32:
        return true;
    }
  }

  evaluarTitulo(titulo: string): boolean {
    if (
      titulo.startsWith('<span class="sa-center">Ret.') ||
      titulo.startsWith('<span class="sa-center">Comisión') ||
      titulo.startsWith('<span class="sa-center">Devolución') ||
      titulo.startsWith('<span class="sa-center">Depósito')
    ) {
      return false;
    }
    return true;
  }

  evaluarEstadoMov(estado: string): boolean {
    switch (estado) {
      case estadoMovimiento.ANULADO:
        return false;
      case estadoMovimiento.APROBADO:
        return true;
      case estadoMovimiento.ACREDITADO:
        return true;
      case estadoMovimiento.CONFIRMADO:
        return true;
    }
  }

  movIsWithinLast31Days(): boolean {
    const now = new Date();
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(now.getDate() - 32);

    return this.data.fecha >= thirtyDaysAgo && this.data.fecha <= now;
  }

  evaluarMov(data): boolean {
    return (
      this.isCommerce &&
      this.tipoMov(data) &&
      this.evaluarTitulo(data.titulo) &&
      this.evaluarEstadoMov(data.estado) &&
      this.movIsWithinLast31Days()
    );
  }

  isDemo(): boolean {
    return this.CURRENT_ENV == this.DEMO_ENV ? true : false;
  }

  isPSP(billetera): boolean {
    return billetera !== null ? (billetera.length == 4 ? true : false) : false;
  }

  generarTitulo(mov): string {
    let psp = mov.cvuContraparte ? mov.cvuContraparte.slice(3, 7) : '';
    let wallet =
      mov.medioPagoView == 'Transferencia 3.0'
        ? mov.billetera !== null && this.isPSP(mov.billetera)
          ? this.getWalletDom(mov.billetera)
          : mov.billetera !== null && !this.isPSP(mov.billetera)
          ? billeteras[mov.billetera]
          : mov.billetera == null
          ? this.getWalletDom(psp)
          : null
        : mov.medioPagoView;
    return wallet;
  }

  maskCuit(cuit: string): string {
    return cuit.length > 8
      ? `${cuit.substring(0, 2)}-${cuit.substring(2, 10)}-${cuit.substring(10, 11)}`
      : `${cuit.substring(0, 2)}.${cuit.substring(2, 5)}.${cuit.substring(5, 8)}`;
  }

  copyNroOp(nro: string) {
    const textArea = document.createElement('textarea');
    textArea.value = nro;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand('Copy');
    textArea.remove();
    const messageToSend = {
      message_id: deviceMessageId.COPY_TO_CLIPBOARD,
      payload: { text: nro }
    };

    if (
      (this.environment !== this.deviceEnvironmentId.CLOVER &&
        this.nativeBridgeService.nativeBridgeIsActive('androidBridge')) ||
      this.nativeBridgeService.nativeBridgeIsActive('iOSBridge')
    ) {
      this.nativeBridgeService.sendMessageToDevice(JSON.stringify(messageToSend));
    } else {
      console.warn('Bridge not available, just copy to clipboard');
    }
    this.notificationService.showSuccess('DEBIN ID copy to clipboard');
  }

  goBackToList(): void {
    this.router.navigate(['/user/movements/'], { queryParams: { page: this.detailStorage.currentTableMovementPage } });
  }

  getNetoAcreditado() {
    if (this.dataPaymentDetail?.length > 0) {
      const negativeSum = this.getTotal();
      const totalNetoAcreditado = this.data.monto + negativeSum;
      this.data.netoAcreditado = this.data.tipoMovimiento == tipoMovimiento.ENTRANTE ? totalNetoAcreditado : null;
    }
  }

  getTotal(): number {
    return this.dataPaymentDetail.reduce((acc, curr) => {
      return acc + curr.monto;
    }, 0);
  }

  getTotalDescuentos(array: any[]): number {
    const sum = array?.reduce((acc, curr) => {
      if (curr.monto < 0) {
        return acc + curr.monto;
      }
      return acc;
    }, 0);
    return Math.abs(sum);
  }

  showLink() {
    return (
      this.data.conceptoTipo == conceptoTipoEnum.BONIFICACION || this.data.conceptoTipo == conceptoTipoEnum.DEVOLUCION
    );
  }

  showNeto(): boolean {
    return (
      this.data?.tipoMovimiento == 'IncomingTransaction' &&
      this.dataPaymentDetail?.length > 0 &&
      this.data?.conceptoTipo == 'P'
    );
  }

  showTotalDescuentos(array: any[]) {
    return array.every((item) => item.monto < 0);
  }

  async showOriginalMovement(operationId: string) {
    this.operationId = operationId;
    const queryParams = { page: this.detailStorage.currentTableMovementPage, operationId: this.operationId };

    this.router.navigate([], {
      queryParams,
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
    this.getMovementById();
  }

  showPrintButton(movementState: string, conceptoTipo: string, mp: number) {
    return (
      movementState !== estadoMovimiento.PENDIENTE &&
      conceptoTipo !== conceptoTipoEnum.DEPOSITO &&
      this.isTxBancaria(mp)
    );
  }

  isTxBancaria(mp: number) {
    if (this.cloverService.getTerminalId()) {
      return mp !== tipoMp.transferenciaBancaria;
    } else {
      return true;
    }
  }

  isRechazadoMovement(movementState: string) {
    return movementState == estadoMovimiento.RECHAZADO;
  }

  formatPhone(input: string) {
    const numbers = input.match(/\d/g)?.join('') || '';

    if (numbers.length !== 13) {
      return input;
    }

    const formattedNumbers = numbers.replace(/(\d{2})(\d{2})(\d{4})(\d{5})/, '+$1 $2-$3-$4');
    return input.replace(numbers, formattedNumbers);
  }
}

enum conceptoTipoEnum {
  BONIFICACION = 'B',
  COMISION_YACARE = 'C',
  RETENCION = 'I',
  DEVOLUCION = 'V',
  DEPOSITO = 'D',
  PAGO = 'P',
  RETIRO = 'R'
}

enum tipoMovimiento {
  SALIENTE = 'OutboundTransaction',
  ENTRANTE = 'IncomingTransaction'
}

enum estadoMovimiento {
  ANULADO = 'Anulado',
  CONFIRMADO = 'Confirmado',
  APROBADO = 'Aprobado',
  ACREDITADO = 'Acreditado',
  PENDIENTE = 'Pendiente',
  RECHAZADO = 'Rechazado'
}

enum tipoMp {
  cajaPlus = 40,
  cuentaVirtualYacare = 99,
  visaCredito = 1,
  amexCredito = 2,
  visaDebito = 3,
  mastercardCredito = 4,
  maestroDebito = 5,
  mastercardDebito = 6,
  cabalDebito = 7,
  transferenciaBancaria = 30,
  cabalCredito = 8,
  mendozaActiva = 41,
  transferencia30 = 32
}

export interface IMovementDetail {
  fechaAcreditacion: Date;
  estado: string;
  fecha: Date;
  id: number;
  monto: number;
  observaciones: string;
  titulo: string;
  cuilCuitContraparte: string;
  importe: number;

  debinId: string;
  tipoTransaccion: string;
  descripcion: string;
  cvuContraparte: string;
  tipoOperacion: string;
  sucursal: string;
  caja: string | null;
  mpTipo: {
    id: number;
    nombre: string;
    descripcion: string;
    activo: boolean | null;
    fechaVigDesde: string | null;
  };
  conceptoTipo: string;
}
